<div
  id="text-widget_wrapper"
  [ngStyle]="contentStyle"
  [ngClass]="[!isUsingHtmlStructure ? 'position-absolute-fill' : '']"
>
  <div
    [ngStyle]="colorTextAlignStyle"
    [ngClass]="selectedTextStyleClass"
    class="d-contents w-100"
    [innerHTML]="renderedContent | safeHtml"
  ></div>
</div>
